import { useEffect, useMemo, useState } from 'react';

const GIROS = ['logistica', 'transporte', 'paqueteria', 'agricultura', 'servicios', 'comercio', 'otro'];

export default function Empresas({ authHeaders, onEnter }) {
  const [tenants, setTenants] = useState([]);
  const [search, setSearch] = useState('');
  const [giroFilter, setGiroFilter] = useState('');
  const [sort, setSort] = useState({ key: 'name', dir: 'asc' });
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '', giro: '', contact_name: '', address: '', phone: '', email: '', admin_email: '', admin_password: '' });

  async function load() {
    try {
      const res = await fetch('/api/tenants', { headers: authHeaders() });
      if (res.ok) setTenants(await res.json());
    } catch (e) {}
  }
  useEffect(() => { load(); }, []);

  function openCreate() {
    setForm({ name: '', giro: '', contact_name: '', address: '', phone: '', email: '', admin_email: '', admin_password: '' });
    setModal('create');
  }
  function openEdit(t) {
    setForm({ name: t.name || '', giro: t.giro || '', contact_name: t.contact_name || '', address: t.address || '', phone: t.phone || '', email: t.email || '', admin_email: '', admin_password: '' });
    setModal(t.id);
  }
  function close() { setModal(null); }
  function set(k, v) { setForm((p) => ({ ...p, [k]: v })); }

  async function save() {
    if (modal === 'create') {
      if (!form.name.trim()) { alert('El nombre de la empresa es requerido'); return; }
      if (!form.email.trim() && !form.admin_email.trim()) { alert('El correo es requerido'); return; }
      if (!form.admin_password) { alert('La contraseña es requerida'); return; }
    }
    try {
      let res;
      if (modal === 'create') {
        const payload = { ...form, admin_email: (form.admin_email || form.email).trim() };
        res = await fetch('/api/tenants', { method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify(payload) });
      } else {
        res = await fetch('/api/tenants/' + modal, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify({ name: form.name, giro: form.giro, contact_name: form.contact_name, address: form.address, phone: form.phone, email: form.email }) });
      }
      const d = await res.json();
      if (!res.ok) { alert(d.error || 'Error'); return; }
      close();
      await load();
    } catch (e) { alert('Error: ' + e.message); }
  }

  async function remove(t) {
    if (!window.confirm(`¿Eliminar la empresa "${t.name}" y todos sus usuarios, dispositivos y viajes?`)) return;
    try {
      await fetch('/api/tenants/' + t.id, { method: 'DELETE', headers: authHeaders() });
      await load();
    } catch (e) { alert('Error: ' + e.message); }
  }

  function toggleSort(key) {
    setSort((s) => (s && s.key === key ? { key, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }));
  }

  const filtered = useMemo(() => {
    let list = tenants;
    if (search.trim()) {
      const s = search.trim().toLowerCase();
      list = list.filter((t) => [t.name, t.giro, t.contact_name, t.email, t.phone].some((v) => (v || '').toLowerCase().includes(s)));
    }
    if (giroFilter) list = list.filter((t) => t.giro === giroFilter);
    if (sort) {
      list = [...list].sort((a, b) => {
        const av = a[sort.key], bv = b[sort.key];
        if (sort.key === 'devices_count' || sort.key === 'users_count') return sort.dir === 'asc' ? (av || 0) - (bv || 0) : (bv || 0) - (av || 0);
        const c = String(av || '').localeCompare(String(bv || ''));
        return sort.dir === 'asc' ? c : -c;
      });
    }
    return list;
  }, [tenants, search, giroFilter, sort]);

  const columns = [
    { key: 'name', label: 'Empresa' },
    { key: 'giro', label: 'Giro' },
    { key: 'contact_name', label: 'Contacto' },
    { key: 'phone', label: 'Teléfono' },
    { key: 'email', label: 'Correo' },
    { key: 'devices_count', label: 'Dispositivos' },
    { key: 'users_count', label: 'Usuarios' },
  ];

  return (
    <div className="manual">
      <section className="card panel">
        <h2>Empresas</h2>
        <div className="cmd-form">
          <input type="text" placeholder="🔍 Buscar empresa..." value={search} onChange={(e) => setSearch(e.target.value)} />
          <select value={giroFilter} onChange={(e) => setGiroFilter(e.target.value)}>
            <option value="">Todos los giros</option>
            {GIROS.map((g) => <option key={g} value={g}>{g}</option>)}
          </select>
          <button onClick={openCreate}>＋ Nueva empresa</button>
        </div>
        <table>
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} style={{ cursor: 'pointer' }} onClick={() => toggleSort(c.key)}>
                  {c.label}{sort && sort.key === c.key ? (sort.dir === 'asc' ? ' ▲' : ' ▼') : ''}
                </th>
              ))}
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={8} className="empty">Sin empresas</td></tr>}
            {filtered.map((t) => (
              <tr key={t.id}>
                <td className="mono">{t.name}</td>
                <td>{t.giro || '—'}</td>
                <td>{t.contact_name || '—'}</td>
                <td>{t.phone || '—'}</td>
                <td>{t.email || '—'}</td>
                <td>{t.devices_count}</td>
                <td>{t.users_count}</td>
                <td>
                  {onEnter && <button className="mini" onClick={() => onEnter(t.id)}>Abrir</button>}
                  <button className="mini" onClick={() => openEdit(t)}>Editar</button>
                  <button className="mini del" onClick={() => remove(t)}>Borrar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {modal && (
        <div className="modal-overlay" onClick={close}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{modal === 'create' ? 'Nueva empresa' : 'Editar empresa'}</h2>
            <h3>Datos generales</h3>
            <div className="reg-grid">
              <label>Nombre *<input value={form.name} onChange={(e) => set('name', e.target.value)} /></label>
              <label>Giro
                <select value={form.giro} onChange={(e) => set('giro', e.target.value)}>
                  <option value="">— Selecciona —</option>
                  {GIROS.map((g) => <option key={g} value={g}>{g}</option>)}
                </select>
              </label>
              <label>Contacto<input value={form.contact_name} onChange={(e) => set('contact_name', e.target.value)} /></label>
              <label>Teléfono<input value={form.phone} onChange={(e) => set('phone', e.target.value)} /></label>
              <label>Correo<input value={form.email} onChange={(e) => set('email', e.target.value)} /></label>
              <label>Dirección<input value={form.address} onChange={(e) => set('address', e.target.value)} /></label>
            </div>
            {modal === 'create' && (
              <>
                <h3>Credenciales de acceso a la empresa</h3>
                <p className="dim" style={{ marginTop: -4, marginBottom: 10 }}>Con este usuario y contraseña ingresará el administrador de la empresa.</p>
                <div className="reg-grid">
                  <label>Correo de acceso (opcional)<input value={form.admin_email} onChange={(e) => set('admin_email', e.target.value)} placeholder="usa el Correo si se deja vacío" /></label>
                  <label>Contraseña *<input value={form.admin_password} onChange={(e) => set('admin_password', e.target.value)} placeholder="contraseña" /></label>
                </div>
              </>
            )}
            <div className="cmd-form">
              <button onClick={save}>{modal === 'create' ? 'Crear' : 'Guardar'}</button>
              <button className="secondary" onClick={close}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
